webpackJsonp([22],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* unused harmony export server */
/* unused harmony export host */
/* unused harmony export passportHost */
var serverConfigs = __webpack_require__(8);
var ENV = "prod_na";
var server = serverConfigs[ENV];

var host = server.host;
var passportHost = server.passportHost;

/* harmony default export */ __webpack_exports__["a"] = ({
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL',
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function getChannel() {
    var channel = this.getReqParam('Channel');
    if (!channel) {
      channel = this.CHANNEL;
    }
    return channel;
  },
  cookieSet: function cookieSet(key, value) {
    var Days = 30;
    var date = new Date();
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString();
  },
  cookieGet: function cookieGet(key) {
    var result;
    var mycookie = document.cookie;
    var start2 = mycookie.indexOf(key + '=');
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1;
      var end = mycookie.indexOf(';', start);
      if (end === -1) {
        end = mycookie.length;
      }
      result = unescape(mycookie.substring(start, end));
    }
    return result;
  },
  getReqParam: function getReqParam(param) {
    var url = window.location.search;
    var theRequest = {};
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
      }
    }
    return theRequest[param];
  },
  appendParam: function appendParam(url, param, value) {
    var archor = '';
    if (url.indexOf('#') > 0) {
      var strs = url.split('#');
      url = strs[0];
      archor = strs[1];
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url = url + param + '=' + encodeURIComponent(value);
    if (archor !== '') {
      url = url + '#' + archor;
    }
    return url;
  },
  getLocalStore: function getLocalStore(key) {
    return localStorage.getItem(key);
  },
  setLocalStore: function setLocalStore(key, value) {
    localStorage.setItem(key, value);
  },
  lang: function lang() {
    var requestLang = this.getReqParam('lang');
    var currentLang = this.cookieGet('lang');
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang;
      this.cookieSet('lang', currentLang);
    }
    if (!currentLang) {
      currentLang = navigator.language;
      if (!currentLang) {
        currentLang = navigator.browserLanguage;
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en';
    }
    return currentLang;
  },
  local4Service: function local4Service() {
    var lang = this.lang();
    var local = lang.replace('-', '_');
    return local;
  },
  urlRemoveParam: function urlRemoveParam(param) {
    var url = window.location.href;
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '');
      var params = window.location.search.substr(1);
      var strs = params.split('&');
      for (var m = 0; m < param.length; m++) {
        var one = param[m];
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1);
            break;
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&');
        hosturl = hosturl + '?' + search;
      }
      url = hosturl + window.location.hash;
    }
    return url;
  }
});

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(93);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("39392ca3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37ecc2e3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_en.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37ecc2e3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_en.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_en_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__privacy_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__ = __webpack_require__(0);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.APP_KEY] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].APP_KEY;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.CHANNEL] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].getChannel();

  next(function (response) {
    return response;
  });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  },
  update: function update(el, binding) {
    document.title = el.dataset.title;
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__privacy_en_vue___default.a);
  }
}).$mount('#privacy_en');

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var docEl = document.documentElement;
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
var remSize = 100;
var recalc = function recalc() {
  var clientWidth = docEl.clientWidth;
  if (!clientWidth) {
    return;
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px';
  } else {
    docEl.style.fontSize = remSize + 'px';
  }
};

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/privacy_en/privacy_en.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] privacy_en.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37ecc2e3", Component.options)
  } else {
    hotAPI.reload("data-v-37ecc2e3", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
};

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacyEn',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacyEn {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacyEn h1 {\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacyEn div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacyEn div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacyEn div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacyEn div a {\n  color: #000;\n}\n#privacyEn div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacyEn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('h1', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('div', [_vm._v("Last updated: Jun 29, 2021")]), _vm._v(" "), _c('div', [_vm._v("CZUR Tech and its affiliates (hereinafter collectively referred to as “CZUR Tech”) respect and protect the privacy of all users who use CZUR Tech services. To provide users with more accurate and personalized services, CZUR Tech may use and disclose users’ personal information in accordance with this Privacy Policy. CZUR Tech will treat users’ information with high diligence and prudence. Except as otherwise provided in this Privacy Policy, CZUR Tech will not disclose or provide users’ information to any third party without users’ prior consent. CZUR Tech will update this Privacy Policy from time to time.")]), _vm._v(" "), _c('div', [_vm._v("By agreeing to CZUR Tech Services Agreement, you are deemed to have agreed to the entire contents of this Privacy Policy. This Privacy Policy is an integral part of CZUR Tech Services Agreement.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("1. Application Scope")]), _vm._v(" "), _c('div', [_vm._v("a) Personal registration information provided by you when you register for a CZUR account;")]), _vm._v(" "), _c('div', [_vm._v("b) Information on your browser and computer that are automatically received and recorded by CZUR Tech when you use CZUR Tech network services or access to the websites of CZUR Tech, including but not limited to your IP address, browser type, language used, date and time of access, hardware and software features, and web page records you need, etc.")]), _vm._v(" "), _c('div', [_vm._v("c) Users’ personal data obtained by the company from a business partner through legal channels.")]), _vm._v(" "), _c('div', [_vm._v("You understand and agree that the following information does not apply to this Privacy Policy:")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("● The keyword information that you enter when using the search service provided by CZUR Tech;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("● Information and data that you publish on CZUR Tech platform and collected by CZUR Tech, including but not limited to information concerning participating activities, transaction and rating details;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("● Your violation of laws or rules of CZUR Tech and the measures that CZUR Tech has taken against you.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("2. Information Use")]), _vm._v(" "), _c('div', [_vm._v("a) CZUR Tech will not provide, sell, rent, share or trade your personal information to any unrelated third party, unless we have your consent in advance, or the third party and CZUR Tech (including CZUR Tech’s affiliates) respectively or jointly provide services to you, and after the service, the third party will be banned from accessing all such information that it has previously been able to access.")]), _vm._v(" "), _c('div', [_vm._v("b) CZUR Tech does not allow any third party to collect, edit, sell or distribute your personal information by any means. CZUR Tech has the right to immediately terminate the services agreement with the user if he or she involves in the above activities.")]), _vm._v(" "), _c('div', [_vm._v("c) To offer you services, CZUR Tech may use your information to offer you with contents that you are interested in, including but not limited to sending you product and service information, or sharing information with CZUR Tech’s partners, so that they can send you information about their products and services (the latter requires your prior consent).")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("3. Information Disclosure")]), _vm._v(" "), _c('div', [_vm._v("Under the following circumstances, CZUR Tech will disclose your personal information wholly or partially according to your personal willingness or the law:")]), _vm._v(" "), _c('div', [_vm._v("a) Discloses your information to third parties with your prior consent;")]), _vm._v(" "), _c('div', [_vm._v("b) Shares your information with third parties so as to provide the products and services you request;")]), _vm._v(" "), _c('div', [_vm._v("c) Discloses your information to third parties or administrative or judicial authorities in accordance with relevant law and provisions, or at the request of administrative or judicial authorities;")]), _vm._v(" "), _c('div', [_vm._v("d) Discloses your information to a third party when you have violated relevant China’s laws, regulations or the CZUR Tech Services Agreement or related rules;")]), _vm._v(" "), _c('div', [_vm._v("e) In the case that you are a qualified intellectual property complainant and have filed a complaint, and your information should be disclosed to the respondent at the request of the respondent so that both parties can handle possible rights disputes;")]), _vm._v(" "), _c('div', [_vm._v("f) In a transaction created on the CZUR Tech platform, if any transaction party performs or partially performs the transaction obligation and makes request for information disclosure, CZUR Tech has the right to provide the user with the necessary info, such as contact information to the counter party to facilitate the transaction or solve disputes.")]), _vm._v(" "), _c('div', [_vm._v("g) Other disclosures that CZUR Tech believes to be appropriate in accordance with laws, regulations or website policies.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("4. Disclosures without User Consent")]), _vm._v(" "), _c('div', [_vm._v("According to relevant laws and regulations, collecting your information in the following cases does not require your consent:")]), _vm._v(" "), _c('div', [_vm._v("a) Cases related to national security and national defense security;")]), _vm._v(" "), _c('div', [_vm._v("b) Cases related to public safety, public health, and major public interests;")]), _vm._v(" "), _c('div', [_vm._v("c) Cases related to criminal investigation, prosecution, trial, and judgments execution;")]), _vm._v(" "), _c('div', [_vm._v("d) Cases related to important legal rights, such as life or property interests of the information subject or other individuals, but is difficult to get your own consent;")]), _vm._v(" "), _c('div', [_vm._v("e) The information collected is disclosed to the public by yourself;")]), _vm._v(" "), _c('div', [_vm._v("f) Information collected from legal publishing channels, such as legitimate news reports, government information disclosure channels, etc.;")]), _vm._v(" "), _c('div', [_vm._v("g) Necessary information for signing a contract according to your requirements;")]), _vm._v(" "), _c('div', [_vm._v("h) Necessary information for safe and stable operation of CZUR Tech services, such as for the discovery or disposal of products or services;")]), _vm._v(" "), _c('div', [_vm._v("i) Necessary information for legal news reporting;")]), _vm._v(" "), _c('div', [_vm._v("j) Necessary information for academic research institutions that conduct statistical or academic research based on public interest and provide academic research or description results where information contained in the results is de-identified;")]), _vm._v(" "), _c('div', [_vm._v("k) Other circumstances as stipulated by laws and regulations.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("5. Information Storage and Exchange")]), _vm._v(" "), _c('div', [_vm._v("The information and data collected by CZUR Tech will be stored on the servers of CZUR Tech and/or its affiliates, which may be transmitted to your country or region or be accessed, stored or displayed outside the country or region where the information and data are collected.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("6. Cookies Use")]), _vm._v(" "), _c('div', [_vm._v("a) In the event that you accept cookies, CZUR Tech will set or access cookies on your computer so that you can log in to or use cookies-based CZUR platform services or features. CZUR Tech uses cookies to provide you with more thoughtful and personalized services, including promotional services.")]), _vm._v(" "), _c('div', [_vm._v("b) You have the right to accept or decline cookies. You can refuse cookies by changing your browser settings. However, if you choose to decline cookies, you may not be able to log in to or use cookies-based CZUR platform services or features.")]), _vm._v(" "), _c('div', [_vm._v("c) This policy will apply to information obtained through cookies set by CZUR Tech.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("7. Information Security")]), _vm._v(" "), _c('div', [_vm._v("a)  CZUR accounts have security protection function. Please carefully keep your username and password. CZUR Tech will ensure that your information will not be lost, abused or altered with security measures such as encrypting user passwords. Despite the aforementioned security measures, please note that there are no “perfect security measures” on information network.")]), _vm._v(" "), _c('div', [_vm._v("b) When making online transactions with CZUR Tech network services, you will inevitably disclose your personal information, such as contact information or postal address to the counter party or potential counter party. Please take care of your personal information and provide them to others only when necessary. If you find that your personal information is leaked, especially if the username and password are leaked, please contact CZUR’s customer service immediately.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("8. Description of software privacy rights")]), _vm._v(" "), _c('div', [_vm._v("a) Display the pop-up box and full screen interface to other applications.")]), _vm._v(" "), _c('div', [_vm._v("b) Allows the app to modify or delete photos, media content, and files on the memory card.")]), _vm._v(" "), _c('div', [_vm._v("c) The app are allowed to obtain location information based on GPS, base station, Wi Fi and other network sources. This may increase power consumption.")]), _vm._v(" "), _c('div', [_vm._v("d) Allows the app to retrieve user location information when running in the background.")]), _vm._v(" "), _c('div', [_vm._v("e) Allow the app to record audio.")]), _vm._v(" "), _c('div', [_vm._v("f) Allow the app to take photos and videos.")]), _vm._v(" "), _c('div', [_vm._v("g) Allows the app to read photos, media content, and files on the memory card.")]), _vm._v(" "), _c('div', [_vm._v("h) Allow the app to get the phone number, call status and dialed number.")]), _vm._v(" "), _c('div', [_vm._v("i) Modify the settings in the settings application.")]), _vm._v(" "), _c('div', [_vm._v("j) Allow the app to open Bluetooth permissions and connect BLE Bluetooth devices.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("9.Information collected by third-party services and security guarantee functions:")]), _vm._v(" "), _c('div', [_vm._v("a) com.tencent.bugly (Bugly; Tencent Bugly); Information Collected: Requires network and storage permissions, collects basic device information such as brand, model; Purpose: Provide exception log analysis services; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("b) com.huawei.hms (Huawei; Huawei Push); Information Collected: Unique device identifier, Token, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("c) com.sina.weibo (Weibo; Sina Weibo); Information Collected: Device information; Purpose: For sharing, third-party login; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_vm._v("e) com.huawei.agconnect (Huawei; Huawei Joint Operation Application); Information Collected: Device information; Purpose: Huawei App Market distribution service; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("f) cn.jpush.android (Aurora; Aurora Push); Information Collected: Device information, geographical location, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_vm._v("h) com.eg.android.AlipayGphone (Alipay); Information Collected: Device information (such as IMEI, IMSI, SIM card serial number, MAC address, AndroidID, SSID, BSSID, basic device information [model\\manufacturer etc.]), network information; Purpose: Purchase VIP services etc.; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("i) com.xiaomi.mipush (Xiaomi; Xiaomi Push); Information Collected: Unique device identifier, Token, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("j) com.heytap.mcs (OPPO; OPPO push); Information Collected: Unique device identifier, Token, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("k) com.vivo.push (VIVO; VIVO push); Information Collected: Unique device identifier, Token, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("l) io.agora (Sound Network); Information Collected: Device type, device model, CPU information, battery power information, operating system information, sender and receiver user ID, user attributes, channel information, usage duration, channel setting name, log; Purpose: Provide video and audio conference function; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_vm._v("This is some content in the privacy policy of the application, please help me translate it into English.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("10. Special provisions applicable to certain country/region")]), _vm._v(" "), _c('div', [_vm._v("Regarding the personal information collected and generated in China (for the purpose of this clause, excluding HK, Macao and Taiwan), we will comply with the PRC Cybersecurity Law on cross-border transfer of personal information and important business data by operator of key information infrastructure.")]), _vm._v(" "), _c('div', [_vm._v("In Hong Kong Special Administrative Region, Macao Special Administrative Region and Taiwan, Our Products and services will comply with all applicable legal provisions of each of the regions including but not limited to the HK Personal Data (Privacy) Ordinance.")]), _vm._v(" "), _c('div', [_vm._v("In the circumstance where the EU General Data Protection Regulation applies to the services provided by us, we commit that you will in addition have the relevant rights and interests under the Regulation including but not limited to right of access to data (you have the right to obtain from us confirmation as to whether or not personal data concerning you are being processed, where they are being processed and for what purpose they are being processed), right to data portability (under certain condition, we will provide to you or another designated data controller upon your request your data in the form stipulated by the Regulation), right to erase (under certain condition, we will erase all personal data concerning you without undue delay upon your request).")]), _vm._v(" "), _c('div', [_vm._v("In the United States, Our Products and services will comply with all applicable legal provisions including but not limited to the US Privacy Act, the US Electronic Communications Privacy Act and the US Children's Online Privacy Protection Act.")]), _vm._v(" "), _c('div', [_vm._v("If your rights and interests under the applicable legal provisions differ from what is stipulated herein, that part of the applicable legal provisions prevails, provided, however, in case the abovementioned legal provision conflicts with the mandatory provision under the governing law of the Privacy Policy, we will on the premise of abiding by the mandatory provision, comply with the applicable legal provision to the extent possible.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("11. Notification and Revision")]), _vm._v(" "), _c('div', [_vm._v("We may revise the terms of this Privacy Policy as appropriate and such modifications form part of this Privacy Policy. For major changes, we will provide clear notices, and you may opt out of CZUR Tech services; in such case, if you continue to use CZUR Tech services, it indicates that you agree to the revised Privacy Policy.")]), _vm._v(" "), _c('div', [_vm._v("We always put your satisfaction in the first place and we encourage you to review our Privacy Policy each time you use CZUR Tech services.")]), _vm._v(" "), _c('div', [_vm._v("We may issue service-related announcements when necessary (for example, when we suspend a service due to system maintenance). You may not be able to cancel these announcements that are related to the services and that are not promotion.")]), _vm._v(" "), _c('div', [_vm._v("You are obligated to keep your account and password confidential.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("12. Contact Us")]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("d) com.umeng (Umeng); Information Collected: Device information (IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM card IMSI/ICCID), location information, network information; Purpose: For third-party (WeChat, QQ) shared login, sharing; Collection Method: Local collection on mobile phone through SDK. Detailed privacy policy link:\n     "), _c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy"
    }
  }, [_vm._v("https://www.umeng.com/page/policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("g) "), _c('a', {
    attrs: {
      "href": "com.tencent.mm"
    }
  }, [_vm._v("com.tencent.mm")]), _vm._v(" (WeChat); Information Collected: MAC address, unique device identifier; Purpose: Purchase VIP services etc.; Collection Method: Local collection on mobile phone through SDK.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("For more detailed information, you can visit: "), _c('a', {
    attrs: {
      "href": "https://passport.czur.cc/3dsharelist.html"
    }
  }, [_vm._v("https://passport.czur.cc/3dsharelist.html")]), _vm._v(" Device Information")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("If you have any complaints or reports about the network information security, or if you have any questions, comments or suggestions about this Privacy Policy, your information, or any questions regarding this statement or the privacy policy of CZUR Tech, please contact us at: \n     "), _c('a', {
    attrs: {
      "href": "mailto:service@czur.com"
    }
  }, [_vm._v("service@czur.com")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37ecc2e3", module.exports)
  }
}

/***/ })

},[263]);


// WEBPACK FOOTER //
// static/js/module/privacy_en.8fb34afb6812afb7d5b0.js